import { Link, Navigate } from "react-router-dom";
import React, { Component } from "react";
import { GoogleLogin } from "react-google-login";
const { NotificationManager } = require("react-notifications");
import { Spinner } from "../../Component/Spinner";
import { Alert } from "../../Component/Alert";
import AuthField from "../AuthField/AuthField";
import AuthWindow from "../AuthWindow/AuthWindow";
import Card from "@mui/material/Card";
import { GOOGLE_CLIENT_ID } from "../../constants/auth";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";

interface SignupProps {
    usernameError: string;
    emailError: string;
    passwordError: string;
    returnedError: string;
    confirmPasswordError: string;
    setError: Function;
    processGoogleResponse: Function;
    handleSubmit: Function;
    status: string;
    statusMessage: string;
}

class Signup extends Component<SignupProps, any> {
    emailRef: React.RefObject<HTMLInputElement>;
    usernameRef: React.RefObject<HTMLInputElement>;
    passwordRef: React.RefObject<HTMLInputElement>;
    confirmPasswordRef: React.RefObject<HTMLInputElement>;

    constructor(props: any) {
        super(props);

        this.state = {
            isSocialSignup: false
        };

        this.emailRef = React.createRef();
        this.usernameRef = React.createRef();
        this.passwordRef = React.createRef();
        this.confirmPasswordRef = React.createRef();

        this.confirmSamePassword = this.confirmSamePassword.bind(this);
        this.doSignUp = this.doSignUp.bind(this);
        this.googleResponse = this.googleResponse.bind(this);
        this.errors = this.errors.bind(this);
        this.passwordMismatch = this.passwordMismatch.bind(this);
    }

    doSignUp = (ev: React.FormEvent<HTMLFormElement>) => {
        var component: any = this;
        ev.preventDefault();

        this.props.setError({
            emailError: "",
            usernameError: "",
            returnedError: ""
        });
        component.setState({
            loading: true
        });

        const email = this.emailRef.current!.value;
        const username = this.usernameRef.current!.value;
        const password = this.passwordRef.current!.value;
        const confirmPassword = this.confirmPasswordRef.current!.value;

        this.confirmSamePassword();

        if (email.length < 5) {
            this.props.setError({ emailError: "Email is not long enough" });
        }

        if (password.length < 8) {
            this.props.setError({
                passwordError: "Password is not long enough"
            });
        }

        if (username.length < 3) {
            this.props.setError({
                usernameError: "Username is not long enough"
            });
        }

        if (this.errors()) return;
        this.props.handleSubmit(email, username, password, confirmPassword);
    };

    errors(): boolean {
        return (
            this.props.usernameError.length > 0 ||
            this.props.passwordError.length > 0 ||
            this.props.emailError.length > 0 ||
            this.props.confirmPasswordError.length > 0
        );
    }

    passwordMismatch() {
        return (
            this.passwordRef.current!.value !==
            this.confirmPasswordRef.current!.value
        );
    }

    confirmSamePassword() {
        if (this.passwordMismatch()) {
            return this.props.setError({
                confirmPasswordError: "Passwords do not match"
            });
        }

        this.props.setError({
            confirmPasswordError: ""
        });
    }

    onFailure = (err: string) => {
        NotificationManager.error(
            "Click to Dismiss",
            "Could not login with google because " + err,
            5000
        );
    };

    googleResponse(res: any) {
        this.props.processGoogleResponse(res);

        this.setState({
            isSocialSignup: true
        });
    }

    render() {
        if (this.state.isSocialSignup) {
            return <Navigate to="/finish-social-signup" />;
        }

        var returnedError: JSX.Element = <div></div>;

        if (this.state.returnedError) {
            returnedError = (
                <div className="alert alert-warning" role="alert">
                    <strong>Error Logging in!</strong>{" "}
                    {this.state.returnedError}
                </div>
            );
        }

        return (
            <AuthWindow
                image="/images/red-and-multicolored-figure-1333320.jpg"
                source_url="https://www.pexels.com/photo/red-and-multicolored-figure-1333320/?utm_content=attributionCopyText&utm_medium=referral&utm_source=pexels"
                author="Magda Ehlers"
                author_url="https://www.pexels.com/@magda-ehlers-pexels?utm_content=attributionCopyText&utm_medium=referral&utm_source=pexels"
            >
                <Grid container justifyContent="center">
                    <Grid container item xs={12} sm={12} md={4}>
                        <Card>
                            <Alert
                                status={this.props.status}
                                message={this.state.statusMessage}
                            />
                            <div className="form-half">
                                <h1>Register</h1>
                                <br />
                                <GoogleLogin
                                    clientId={
                                        GOOGLE_CLIENT_ID
                                    }
                                    buttonText="Use Google"
                                    onSuccess={this.googleResponse}
                                    onFailure={this.onFailure}
                                    cookiePolicy={"single_host_origin"}
                                />
                                <br />
                                <br />
                                <form
                                    onSubmit={this.doSignUp}
                                    action="/api/v1/signup"
                                    method="post"
                                >
                                        <Grid container spacing={2}>
                                        <Grid
                                                container
                                                item
                                                xs={12}
                                            >

                                    <AuthField
                                        label="Email"
                                        ref={this.emailRef}
                                        error={this.props.emailError}
                                        reference="email"
                                    /></Grid>
                                        <Grid
                                            container
                                            item
                                            xs={12}
                                        >
                                            <AuthField
                                                label="Username"
                                                ref={this.usernameRef}
                                                error={this.props.usernameError}
                                                reference="username"
                                            />
                                        </Grid>
                                        <Grid
                                            container
                                            item
                                            xs={12}
                                        >
                                            <AuthField
                                                label="Password"
                                                ref={this.passwordRef}
                                                error={this.props.passwordError}
                                                reference="password"
                                            />
                                        </Grid>
                                        <Grid
                                            container
                                            item
                                            xs={12}
                                        >
                                            <AuthField
                                                label="Confirm Password"
                                                ref={this.confirmPasswordRef}
                                                error={
                                                    this.props
                                                        .confirmPasswordError
                                                }
                                                reference="confirm-password"
                                            />
                                        </Grid>
                                        <Grid
                                            container
                                            item
                                            justifyContent="center"
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                        >
                                            <div className="form-group">
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                >
                                                    Register
                                                </Button>
                                                <span className="form-warning pull-right">
                                                    <Spinner
                                                        show={
                                                            this.state.loading
                                                        }
                                                    />
                                                </span>
                                            </div>
                                        </Grid>
                                        </Grid>
                                    <div className="form-group">
                                        {returnedError}
                                    </div>
                                </form>
                                <hr />
                                <p>
                                    Already have an account?{" "}
                                    <Link to="/login">Login</Link>
                                </p>
                                <p>
                                    <Link to="/">
                                        <span className="fa fa-home"></span>
                                    </Link>
                                    .
                                </p>
                            </div>
                        </Card>
                    </Grid>
                </Grid>
            </AuthWindow>
        );
    }
}

export default Signup;
